import { render } from "./ImageSpinner.vue?vue&type=template&id=2cde8f42&scoped=true"
import script from "./ImageSpinner.vue?vue&type=script&lang=js"
export * from "./ImageSpinner.vue?vue&type=script&lang=js"

import "./ImageSpinner.vue?vue&type=style&index=0&id=2cde8f42&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cde8f42"]])

export default __exports__